"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _borders = _interopRequireDefault(require("../system/borders"));
var _display = _interopRequireDefault(require("../system/display"));
var _flexbox = _interopRequireDefault(require("../system/flexbox"));
var _palette = _interopRequireDefault(require("../system/palette"));
var _positions = _interopRequireDefault(require("../system/positions"));
var _shadows = _interopRequireDefault(require("../system/shadows"));
var _sizing = _interopRequireDefault(require("../system/sizing"));
var _spacing = _interopRequireDefault(require("../system/spacing"));
var _compose = _interopRequireDefault(require("./compose"));
const box = (0, _compose.default)(_borders.default, _display.default, _flexbox.default, _palette.default, _positions.default, _shadows.default, _spacing.default, _sizing.default);
var _default = exports.default = box;